const PRODUCTS = {
    TUTORIAL_BUILDER_WEB: 'tutorial-builder-web',
    CONTENT_PRODUCTION: 'content-production',
    USER_MANAGEMENT: 'user-management',
    USER_MANAGEMENT_ACCOUNT_AND_PERMISSIONS: 'user-management-account-and-permissions',
};
export const PRODUCT_TITLES = {
    TUTORIAL_BUILDER_WEB: 'Tutorial Builder',
    CONTENT_PRODUCTION: 'Content Production',
    USER_MANAGEMENT: 'User Management',
    USER_MANAGEMENT_ACCOUNT_AND_PERMISSIONS: 'Account & Permissions',
};

export const LCP = 'Learn Content Platform';

export const LOCALIZED_PRODUCTS = [PRODUCTS.TUTORIAL_BUILDER_WEB];

export default PRODUCTS;
